function getCurrentLength(sequence, gap) {
  if (sequence.length === 0)
    return 0;
  return sequence.reduce((sum, apartment) => sum + apartment.unit.size[0] + gap, 0) - gap;
}
export {
  getCurrentLength
};
//# sourceMappingURL=index214.js.map
